import React from "react"
import CapIcon from "../../CapIcon"
import { clsPrefix, MESSAGE_DISLIKE, MESSAGE_LIKE } from "./constants"
import CapRow from "../../CapRow"


export const MetaBlock = ({
    likeAnswer = () => { },
    likeButton,
    disLikeButton,
    content,
    messageId,
    index
}) => {
    const handleCopyClick = async () => {
        try {
            await navigator.clipboard.writeText(content);
        } catch (err) {
            console.log(err);
        }
    };
    return (
        <div className={`${clsPrefix}-meta-data`}>
            <CapRow
                type="flex"
                align="middle"
            >
                <CapIcon
                    type="copy"
                    size="s"
                    className={`${clsPrefix}-refresh-data`}
                    onClick={handleCopyClick}
                    data-testid="copy-button"
                />
            </CapRow>
            <CapRow>
                {likeButton ?
                    <CapIcon
                        size="s"
                        type="filled-like"
                        style={{ marginRight: '0.715rem' }}
                        data-testid="filled-like-button"
                    /> :
                    <CapIcon
                        data-selected={MESSAGE_LIKE}
                        onClick={likeAnswer('like', messageId, index)}
                        size="s" type="like"
                        style={{ marginRight: '0.715rem' }}
                        data-testid="like-button"
                    />
                }
                {disLikeButton ?
                    <CapIcon
                        size="s"
                        type="filled-disLike"
                        style={{ marginRight: '0.715rem' }}
                        data-testid="filled-dislike-button"
                    /> :
                    <CapIcon
                        data-selected={MESSAGE_DISLIKE}
                        onClick={likeAnswer('dislike', messageId, index)}
                        size="s"
                        type="disLike"
                        style={{ marginRight: '0.715rem' }}
                        data-testid="dislike-button"
                    />
                }
            </CapRow>
        </div >
    );
}

